import { render } from "./EasyTroopSpeedUps.vue?vue&type=template&id=0a817dc2&scoped=true"
import script from "./EasyTroopSpeedUps.vue?vue&type=script&lang=js"
export * from "./EasyTroopSpeedUps.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0a817dc2"

export default script